<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/onwbKT/tc-custom/9781504073318.jpg?1737640606278" alt="This image is the cover for the book Hostile, The Tom Hunter Books"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Hostile, The Tom Hunter Books
      </h1>
      <p class="bookDescription body article font2">
        <b>An action-packed tale of shady business, international crime, and an antiviral wonder drug in the series Lee Child called “hard, fast, and really good.”</b><br/>  <br/> A young financial executive has uncovered his new boss’s plan to steal the patents to a new breakthrough drug—but before he can undermine the scheme, he is kidnapped.<br/>  <br/> The notoriously dangerous Chinese businessman will stop at nothing, including abduction and government corruption, to achieve his goal—and enlists a violent Triad gang to wreak mayhem on those who stand in his way. Now kidnap-rescue operative Tom Hunter is thrown into a deadly race against time to save lives and halt the deadly deal . . .
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ted Denton
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Bloodhound Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?570be0e4